import * as React from 'react';
import { Translate } from '../../../shared/LanguageService';
import IRegion from '../types/Region';
import { Table, Button } from 'react-bootstrap';
import RegionListRow from './RegionListRow';

interface IRegionProps {
    items: IRegion[];
    onEdit: (value: IRegion) => void;
    onDelete: (value: IRegion) => void;
}

const RegionList = (props: IRegionProps) => {
    return (
        <Table hover responsive>
            <thead>
                <tr>
                    <th>{Translate('regions/list/header/name')}</th>
                    <th>{Translate('regions/list/header/is-discontinued')}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.items.map((i: IRegion) => (
                    <RegionListRow
                        region={i}
                        key={i.id}
                        onEdit={props.onEdit}
                        onDelete={props.onDelete}
                    />
                ))}
            </tbody>
        </Table>
    );
};

export default RegionList;
